import t from "react";
import { Spinner as n } from "../Spinner/Spinner.mjs";
/* empty css            */
const l = ({
  hasLabel: e
}) => /* @__PURE__ */ t.createElement("div", { className: `rnf-button-spinner rnf-button-spinner--${e ? "with-label" : "without-label"}` }, /* @__PURE__ */ t.createElement(n, null));
export {
  l as ButtonSpinner
};
//# sourceMappingURL=ButtonSpinner.mjs.map
